/** Which screen a failed `/api/auth/me` shows inside Teams, decided by status so support does not chase the manifest when the cause is a missing access level:
 *  403 -> the no-account screen (server wording); no response or 5xx -> unreachable; anything else (401, never reached the API) -> the configuration screen, which also shows the server's detail. */
type TeamsAuthScreen = 'no-account' | 'unreachable' | 'teams-config'

export function teamsAuthScreen(
  status: number | undefined,
  noResponse: boolean,
): TeamsAuthScreen {
  if (status === 403) return 'no-account'
  if (noResponse || (status !== undefined && status >= 500)) return 'unreachable'
  return 'teams-config'
}

/** Whether a failed or empty `/api/auth/me` takes the signed-in shell away. React Query keeps `data` through a failed REFETCH, so `isError` alone let a dropped connection on tab refocus replace the whole app, closing dialogs and re-masking payroll figures although the person was still signed in.
 *  No user: the gate. User and no failure: the shell. User and a failure: the gate only when the API ANSWERED and refused (401, 403); no response or 5xx proves nothing about the session, so the shell stays and `sessionCheckFailed` says the check did not complete. */
export function meGate(
  hasUser: boolean,
  isError: boolean,
  status: number | undefined,
): 'shell' | 'shell-stale' | 'gate' {
  if (!hasUser) return 'gate'
  if (!isError) return 'shell'
  return status === 401 || status === 403 ? 'gate' : 'shell-stale'
}
